<script>
export default {
  name: "MenuPage",
  data() {
    return {
      activeMenu: "latest",
    };
  },
  mounted() {
    this.updateActiveMenu();
  },
  watch: {
    $route() {
      this.updateActiveMenu();
    },
  },
  methods: {
    updateActiveMenu() {
      const path = this.$route.path;
      if (path === "/" || path === "/home") {
        this.activeMenu = "latest";
      } else if (path === "/about") {
        this.activeMenu = "about";
      }
    },
    goToLatest() {
      this.activeMenu = "latest";
      this.$router.push("/");
    },
    goToAbout() {
      this.activeMenu = "about";
      this.$router.push("/about");
    },
  },
};
</script>

<template>
  <div class="menu-wrapper">
    <div
      class="menu-item"
      :class="{ active: activeMenu === 'latest' }"
      @click="goToLatest"
    >
      <span class="menu-icon">📄</span>
      <span class="menu-text">最新文章</span>
    </div>
    <div
      class="menu-item"
      :class="{ active: activeMenu === 'about' }"
      @click="goToAbout"
    >
      <span class="menu-icon">👤</span>
      <span class="menu-text">关于我的</span>
    </div>
  </div>
</template>

<style scoped>
.menu-wrapper {
  padding-top: 10px;
}

.menu-title {
  font-size: 12px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 10px 15px;
  text-align: left;
  margin-bottom: 5px;
}

.menu-item {
  display: flex;
  align-items: center;
  text-align: left;
  color: #b0b0b0;
  font-size: 14px;
  height: 44px;
  padding: 0 15px;
  margin-bottom: 4px;
  border-radius: 8px;
  transition: all 0.25s ease;
  cursor: pointer;
  background-color: transparent;
}

.menu-item:hover {
  background-color: rgba(99, 162, 120, 0.15);
  color: #e0e0e0;
}

.menu-item.active {
  background-color: rgba(99, 162, 120, 0.25);
  color: #ffffff;
  font-weight: 500;
  border-left: 3px solid #63a278;
  padding-left: 12px;
}

.menu-icon {
  font-size: 16px;
  margin-right: 12px;
  opacity: 0.8;
}

.menu-item.active .menu-icon {
  opacity: 1;
}

.menu-text {
  flex: 1;
}
</style>
